export const REVISION_TYPES = [
  "Banklar",
  "Basketbol Sahası",
  "Çocuk Oyun Grubu",
  "Çöp Kovaları",
  "Diğer",
  "Elektrik Direkleri",
  "Futbol Sahası",
  "Havuz",
  "Kamelya",
  "Koşu Yolu",
  "Parkın Tamamı",
  "Spor Aletleri",
  "Spor Sahaları",
  "Sulama Sistemi",
  "Tenis Kortu",
  "Voleybol Sahası",
].sort((a, b) => a.localeCompare(b, "tr"));

export const DEFAULT_REVISION_TYPE = "Çocuk Oyun Grubu";
